<div>
  <a href="javascript:void(0)" (click)="getNetflixToken()" class="rs-btn rs-btn-third rs-btn-neg">
    {{ getRedirectLinkLabel() }}
    <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
  </a>
</div>
